module.exports = __webpack_public_path__ + "static/media/mum_sad.fc72d5c0.gif";